import React from 'react';
import {
  Segment, Grid, Container,
  Header, Divider, Icon, Image
} from 'semantic-ui-react';
import '../style.css';
import winnoGif from '../assets/winno.gif';
import winnoVideo from '../assets/winno-video.mp4';
import winnoScreenShot from '../assets/winno-tabs.png';
import EmailEntryContainer from './EmailEntryContainer';

const LandingFlow = () => {
  return (
    <div className='landing-page'>
      <Segment textAlign='center' vertical>
        <Container text>
          <Header as='h1'>winno</Header>
          <Header as='h3'>
            Reduce the clutter. Save and organize whatever you need online.
          </Header>

          <EmailEntryContainer />
          {/* <p className='note'>
            Currently in limited preview.
            Sign up for updates and early access.
          </p> */}
        </Container>
      </Segment>
      <Segment vertical inverted>
        <Grid columns='equal' stackable textAlign='center'>
          <Grid.Row textAlign='center'>
            <Grid.Column>
              <Icon size='big' name='add'/>
              <Header as='h3'>Quickly declutter.</Header>
              <p>
                Close an entire window full of tabs <br/> with one click.
                Or save one at a time.
              </p>
            </Grid.Column>
            <Grid.Column>
              <Icon size='big' name='tag' />
              <Header as='h3'>Intuitively organize.</Header>
              <p>
                Add as many tags as you need to categorize your entries.
                <b> #todo #job-search.</b>
              </p>
            </Grid.Column>
            <Grid.Column>
              <Icon size='big' name='search'/>
              <Header as='h3'>Seamlessly rediscover.</Header>
              <p>
                Reopen your last tab session or just that article you wanted
                <b> #to-read</b> later, across any device.
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {/* <Image className='screenshot' src={winnoGif}></Image> */}
        <video muted className="media video-demo screenshot" playsInline autoPlay loop="yes">
          <source src= {winnoVideo}/>
        </video>
      </Segment>
      <Segment vertical>
        <Container text>
          <Header as='h2' style={{ fontSize: '2em' }}>The Goal</Header>
          <Divider />
          <p>
            <b>Winno</b> is a simple way to save and categorize your tabs and
            articles. It allows you to reduce the clutter in your browser,
            while safekeeping all of your internet resources.
          </p>
          <p>
            Our vision, however, is not <b>just</b> to allow you to save content,
            and easily retrieve it when you need it, but to help you <b>get
            more</b> out of that content.
          </p>
          <p>
            With <b>winno</b>, we want to make <b>synthesizing</b> your thoughts,
            gleaning <b>insights</b>, and finding <b>inspiration</b> from all of
            those resources a piece of cake.
          </p>
          <EmailEntryContainer />
        </Container>
      </Segment>
      <Segment inverted vertical>
        <Container text className='dictionary-definition'>
          <Header as='h2' className='winno'>
            winno
          </Header>
          <Header inverted as='h4'>
          <i>verb</i>  |  <span>/'winəu/</span>:
          </Header>
          <ul>
            <li>
              find or identify (a valuable or useful part of something).
            </li>
            <li>
              remove things from a group until only the best ones are left.
            </li>
          </ul>
        </Container>
      </Segment>
    </div>
  )
}

export default LandingFlow;



// WEBPACK FOOTER //
// ./src/scenes/LandingFlow/components/LandingPage.js